export const BURGER_OPEN = "BURGER_OPEN";
export const BURGER_TOGGLE = "BURGER_TOGGLE";